import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Row, Card } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { METRICSCHAT } from "../../../shared/constants/Constants";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { loadChatMetricsDataRequest, loadUserMetricsDataRequest } from "../redux/Actions";
import MetricsUser from "./MetricsUser";
import MetricsGroup from "./MetricsGroup";

const Metrics = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
  let {chatmetrics, user} = useSelector((state) => state.chatgroup);
  console.log("Data", chatmetrics,user);

  let [currentTracker, setCurrentTracker] = useState(location.search === "?products" ? 2 : 1);

  useEffect(() => {
    //dispatch(loadUserMetricsDataRequest());
    //dispatch(loadChatMetricsDataRequest());
    
  }, [dispatch]);

  let trackers = [
    <MetricsGroup />,
    <MetricsUser />
    
  ];

  return (
    <>
      <div>
        <Row>
          <Col className="gx-0">
            <Breadcrumbs
              children={[
                { label: METRICSCHAT },
              ]}
            />
          </Col>
          <Col xs="auto" className="gx-0"></Col>
        </Row>
        <Row>
          <Col>
            <button
              className={currentTracker === 1 ? "top-tab selected" : "top-tab"}
              onClick={() => {
                navigate("/metrics");
                setCurrentTracker(1);
              }}
            >
              Group 
            </button>
            <button
              className={currentTracker === 2 ? "top-tab selected" : "top-tab"}
              onClick={() => {
                navigate("/metrics");
                setCurrentTracker(2);
              }}
            >
              Users
            </button>
            <div className="mb-1">
              <select
                className="float-end form-control form-select"
                style={{
                  width: '200px',
                  marginTop:'-40px',
                  zIndex: 1000,
                  backgroundColor: '#fff9f5', 
                  color: '#333', 
                  borderColor: '#ff7f0e', 
                  appearance: 'none', 
                  paddingRight: '2rem', 
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23ff7f0e' d='M0 0L2 2L4 0z'/%3E%3C/svg%3E")`, // Red arrow
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'right 0.75rem center',
                  backgroundSize: '1rem auto',
                  height: 'calc(2.25rem + 2px)', 
                          lineHeight: '1.5', 
                }}
                onChange={(e) => {
                  const selectedPath = e.target.value;
                  if (selectedPath) {
                  navigate(selectedPath);
                  }
                }}
              >
              <option value="/metrics?filter=none">Chat Metrics</option>
              <option value="/dashboard?filter=none">MDS Metric</option>              
              <option value="/wvappmetrics?filter=none">WV App Metrics</option>
              </select>
            </div>
            <Card> <Card.Body >{trackers[currentTracker - 1]} </Card.Body> </Card>
          </Col>

        
        </Row>
      </div>
    </>
  );
};

export default Metrics;

